import { render, staticRenderFns } from "./EditCategoryExpenses.vue?vue&type=template&id=7d48d793&"
import script from "./EditCategoryExpenses.vue?vue&type=script&lang=js&"
export * from "./EditCategoryExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports